import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { unByKey } from 'ol/Observable';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import * as olProj from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import axios from 'src/app/Service/axios';
import { NotificationService } from 'src/app/Service/notification.service';
import { Router } from '@angular/router';
import { OtherService } from 'src/app/Service/other.service';
import { MapService } from 'src/app/Service/map.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { BingMaps, XYZ } from 'ol/source';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import * as moment from 'moment-jalaali';
declare let $: any;

@Component({
  selector: 'app-location-timeline',
  templateUrl: './location-timeline.component.html',
  styleUrls: ['./location-timeline.component.css']
})

export class LocationTimelineComponent implements AfterViewInit, OnDestroy {
  map: any = {};
  source: any;
  vector: any;
  tooltipData: any;
  layers: any = [];
  allCar: any = [];
  allCar_Temp: any[] = [];
  car: any;

  @ViewChild('mapTarget') mapTarget!: ElementRef<HTMLDivElement>;
  @ViewChild('timePicker') timePicker!: ElementRef<HTMLDivElement>;
  loading = false;
  hasError = false;
  hasSearched = false;
  filtersOpen = true;
  errorMessage = '';
  searchText = '';
  currentPage = 1;
  pageSize = 20;
  pagedRows: any[] = [];
  resultDate = '';
  resultTime = '';
  private destroyed = false;
  private resizeObserver?: ResizeObserver;
  private mapEvents: any[] = [];
  private focusTimer?: ReturnType<typeof setTimeout>;

  private bOfflineMap: boolean = (<any>window).bOfflineMap;
  private strMapUrl: string = (<any>window).strMapUrl;

  mdl_Search: FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),
    strSession: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('Session')!)),
    strDate: new FormControl(moment().subtract(1, 'day').format('jYYYY/jMM/jDD'), Validators.required),
    strTime: new FormControl('08:00', [Validators.required, Validators.pattern(/^([01]\d|2[0-3]):[0-5]\d$/)]),
  });

  constructor(
    private _tooltip: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private formBuilder: FormBuilder,
    private mapService: MapService,
    private gurdService: GurdServiceService,
  ) { }

  ngAfterViewInit(): void {
    $(this.timePicker.nativeElement).clockpicker({
      donetext: 'top',
      align: 'top',
      autoclose: true,
      afterDone: () => this.mdl_Search.get('strTime')?.setValue(
        $(this.timePicker.nativeElement).find('input').val()),
    });
    this.newOpenMap();
    this.resizeObserver = new ResizeObserver(() => this.map.updateSize());
    this.resizeObserver.observe(this.mapTarget.nativeElement);
    this.mapEvents = [
      this.map.on('pointermove', (event: any) => {
        if (event.dragging) return;
        const pixel = this.map.getEventPixel(event.originalEvent);
        this.map.getViewport().style.cursor = this.map.hasFeatureAtPixel(pixel) ? 'pointer' : '';
        this.showData(this.mapService.mapPointerMove(pixel, this.map), true);
      }),
      this.map.on('click', (event: any) => {
        if (!event.dragging) this.showData(this.mapService.mapPointerMove(
          this.map.getEventPixel(event.originalEvent), this.map));
      }),
      this.map.getView().on('propertychange', () => this.hideMapTooltips()),
    ];
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    clearTimeout(this.focusTimer);
    this.resizeObserver?.disconnect();
    $(this.timePicker.nativeElement).clockpicker('remove');
    unByKey(this.mapEvents);
    $('#map_tooltip, #map_tooltips').tooltip('dispose');
    this.map?.setTarget(undefined);
    this.map?.dispose();
  }

  private hideMapTooltips(): void {
    $('#map_tooltip, #map_tooltips').tooltip('hide');
    this.tooltipData = null;
  }

  newOpenMap() {

    this.source = new VectorSource({ wrapX: false });

    this.vector = new VectorLayer({ source: this.source });

    if (this.bOfflineMap) {

      this.layers.push(

        new TileLayer({

          source: new XYZ({

            // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

            url: this.strMapUrl,

            attributions: 'Map data © RayanAndishehNasr' // 

          }),

        })

      );

    }

    else {

      const styles = ['AerialWithLabelsOnDemand'];

      let i, ii;

      for (i = 0, ii = styles.length; i < ii; ++i) {

        this.layers.push(

          new TileLayer({

            visible: false,

            preload: Infinity,

            source: new BingMaps({

              key: 'AnyK3Znr5dGRC7QqdZpTT3vbxpdcxPWB5ehWfJYf9k1Iq-b-jZrYKiX1NkSLKNi-',

              imagerySet: styles[i],

            }),

          }),

        );

      }

      this.layers.push(new TileLayer({

        visible: true,

        source: new OSM({}),

      }))

    }

    this.layers.push(this.vector);

    this.map = new Map({

      layers: this.layers,

      target: this.mapTarget.nativeElement,

      view: new View({

        center: olProj.fromLonLat([51.3833554, 35.6770113]),

        zoom: 13,

      }),

    });

  }

  async search_Timeline(): Promise<void> {
    if (this.loading || this.destroyed) return;
    this.mdl_Search.get('strTime')?.setValue($(this.timePicker.nativeElement).find('input').val());
    if (this.mdl_Search.invalid) {
      this.filtersOpen = true;
      this.mdl_Search.markAllAsTouched();
      this._tooltip.showError('تاریخ و ساعت را مشخص کنید');
      return;
    }
    this.filtersOpen = false;
    const payload = this.otherService.stringNumberToNumber(this.mdl_Search.value);
    this.loading = true;
    this.hasError = false;
    this.hasSearched = true;
    this.errorMessage = '';
    this.searchText = '';
    this.allCar = [];
    this.allCar_Temp = [];
    this.car = [];
    this.updatePage(true);
    clearTimeout(this.focusTimer);
    this.hideMapTooltips();
    this.mapService.removeLayerByName('car', this.map);
    try {
      const response = await axios.post('FleetYar_Car_ListAtTime', payload);
      if (this.destroyed) return;
      const result = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
      const status = Array.isArray(result) ? result[0] : result;
      if (status?.ISSessionExpired || status?.ISessionExpired) {
        this._tooltip.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        void this.router.navigate(['login'], { queryParams: { error: 'x123s3dw310' } });
        return;
      }
      if (!Array.isArray(result)) throw new Error(result?.strError || 'دریافت اطلاعات ناموفق بود');
      this.allCar = result;
      this.allCar_Temp = result;
      this.resultDate = payload.strDate;
      this.resultTime = payload.strTime;
      this.updatePage(true);
      await this.carfun(result);
    } catch (error) {
      if (this.destroyed) return;
      this.hasError = true;
      this.errorMessage = error instanceof Error ? error.message : 'اتصال به سرور را بررسی و دوباره تلاش کنید.';
      this.allCar = [];
      this.allCar_Temp = [];
      this.car = [];
      this.updatePage(true);
      this.mapService.removeLayerByName('car', this.map);
    } finally {
      if (!this.destroyed) this.loading = false;
    }
  }

  async carfun(data: any, fit?: boolean) {

    var resp = {} as any;

    resp.data = data;

    if (resp.data[0] && resp.data[0].ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '105s' } });


    }

    if (resp.data == null) {

      return this._tooltip.showError('بروز خطا در سامانه');

    }

    else {

      this.car = resp.data;

      if (this.car.length == 1 && this.car[0].bIncomplete == true) {

        return this.router.navigate([`/entryCar/1/${this.car[0]?.strUnitId ? this.car[0].strUnitId : this.car[0].strUnitID}`]);

      }

      //Craete Marker

      if (this.car.length != 0) {

        // resp.data.forEach((element: any, index: number) => {

        for (let index = 0; index < resp.data.length; index++) {

          if (resp.data[index].fLon != 0 && resp.data[index].fLat != 0) {

            //? ترسیم ایکن خودرو توسط تصویر base64

            // var marker = this.mapService.createMarker([resp.data[index].fLon, resp.data[index].fLat], 'data:image/jpeg;base64,' + resp.data[index].strMobileIcon, `${index}`, `car`, {

            // Id: resp.data[index].strUnitId,

            //? ترسیم ایکن خودرو توسط نام ارسالی از سرور

            var marker = this.mapService.createMarker([resp.data[index].fLon, resp.data[index].fLat], `../../../assets/mobile-icons/${resp.data[index].strIconName}`, `${index}`, `car`, {

              Id: resp.data[index].strUnitID,

              ...this.buildCarTooltipHtml(resp.data[index]),
            });

            this.map.addLayer(marker);

          }

          // });
        };

        //Handel fit content Map

        if (fit != false) {

          this.fitMap(resp.data)

        }

      }

    }

  }

  private buildCarTooltipHtml(car: any) {
    const escape = (value: unknown) => String(value ?? '').replace(/[&<>"']/g, character =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]!));
    const name = escape(car.strFullName || 'نامشخص');
    const type = escape(car.strMobileType_strComment);
    const detailUrl = escape(this.router.serializeUrl(
      this.router.createUrlTree(['/carInfo', car.strUnitID ?? car.strUnitId])));
    const dot = typeof car.bOnline === 'boolean'
      ? `<span class="mk-tooltip__dot ${car.bOnline ? 'is-online' : 'is-offline'}"></span>`
      : '';
    const rows = [
      ['tachometer', 'کارکرد', `${(car.fLastKM ?? 0).toLocaleString()} کیلومتر`],
      ['hashtag', 'پلاک', car.strVehicleNo],
      ['clock-o', 'ساعت', car.strTime],
      ['calendar', 'تاریخ', car.strDate],
      ['signal', 'وضعیت دستگاه', car.strDeviceStatus_strComment],
    ].map(([icon, label, value]) => `
      <div class="mk-tooltip__row">
        <span class="mk-tooltip__lbl"><i class="fa fa-${icon}" aria-hidden="true"></i>${label}</span>
        <span class="mk-tooltip__val">${escape(value || '—')}</span>
      </div>`).join('');

    return {
      html: `<div class="mk-tooltip">
        <div class="mk-tooltip__head">
          <div class="mk-tooltip__title">
            <div class="mk-tooltip__name">${name}</div>
            <div class="mk-tooltip__type">${type}</div>
          </div>
          ${dot}
        </div>
        <div class="mk-tooltip__body">${rows}</div>
        <a class="mk-tooltip__btn" href="${detailUrl}" target="_blank" rel="noopener noreferrer">جزییات کامل</a>
      </div>`,
      html2: `<div class="mk-tooltip mk-tooltip--mini">
        ${dot}
        <span class="mk-tooltip__name">${name}</span>
        <span class="mk-tooltip__type">${type}</span>
      </div>`,
    };
  }

  showData(item: any, hover?: boolean) {
    const tooltip = hover ? $('#map_tooltips') : $('#map_tooltip');
    const data = item.featureLayer?.feature.get('data');
    if (!data?.html) {
      tooltip.tooltip('hide');
      this.tooltipData = null;
      return;
    }

    tooltip.tooltip({
      html: true,
      animation: true,
      trigger: 'manual',
      placement: 'top',
      fallbackPlacements: ['top', 'bottom', 'left', 'right'],
      boundary: this.mapTarget.nativeElement,
      offset: [0, 8],
      template: '<div class="tooltip mk-tip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner mk-tip-inner"></div></div>',
    });
    tooltip.css({
      left: item.pixel[0] + 'px',
      top: item.pixel[1] - 14 + 'px',
      zIndex: 1000,
    });

    if (!hover) {
      this.tooltipData = data.html;
      tooltip.attr('data-bs-original-title', data.html).tooltip('show');
      $('#map_tooltips').tooltip('hide');
    } else if (this.tooltipData !== data.html) {
      tooltip.attr('data-bs-original-title', data.html2).tooltip('show');
    }
  }

  filterVehicles(): void {
    const query = this.searchText.trim();
    this.allCar = this.allCar_Temp.filter((row: any) =>
      ['strFullName', 'strMobile', 'strTime'].some(key => String(row[key] ?? '').includes(query)));
    this.updatePage(true);
    clearTimeout(this.focusTimer);
    this.hideMapTooltips();
    this.mapService.removeLayerByName('car', this.map);
    void this.carfun(this.allCar);
  }

  private updatePage(resetPage = false): void {
    if (resetPage) this.currentPage = 1;
    this.currentPage = Math.min(this.currentPage, Math.max(1, Math.ceil(this.allCar.length / this.pageSize)));
    const start = (this.currentPage - 1) * this.pageSize;
    this.pagedRows = this.allCar.slice(start, start + this.pageSize);
  }

  changePage(page: number): void {
    this.currentPage = page;
    this.updatePage();
  }

  changePageSize(size: number): void {
    this.pageSize = size;
    this.updatePage(true);
  }

  trackByVehicle(_index: number, row: any): string {
    return row.strUnitID || row.strUnitId;
  }

  fitMap(data?: any) {

    if (data == null) {

      data = this.car;

    }

    if (!data?.length) return;

    this.mapService.fitMap(data, this.map);

    if (data.length == 1) {

      this.map.getView().setZoom(17);

    }

  }

  focusOnCar(data: any) {
    if (this.loading || this.destroyed) return;
    clearTimeout(this.focusTimer);

    if (data.fLon != 0 && data.fLat != 0) {

      var view = this.map.getView();

      view.animate({

        zoom: 20,

        center: olProj.transform([data.fLon, data.fLat], 'EPSG:4326', 'EPSG:3857'),

      });

      this.focusTimer = setTimeout(() => {

        var coordinates = olProj.transform(

          [data.fLon, data.fLat],

          'EPSG:4326',

          'EPSG:3857'

        );

        var pix = this.map.getPixelFromCoordinate(coordinates);

        var el = this.mapService.mapPointerMove(

          [pix[0] + 18, pix[1] - 27.5],

          this.map

        );

        this.showData(el);

      }, 1200);


    }

  }


}
